module.exports = ":host{display:block}.lui-stepper__seed{-ms-flex-align:baseline;align-items:baseline;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;padding:10px 10px 7px}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-stepper/theme/lui-stepper.scss
// module id = 330
// module chunks = 0 1 7